import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    emailRequired: translate({
      id: 'sms4.settings.communication.notifications.testModal.body.error.email.required',
    }),

    emailInvalid: translate({
      id: 'sms4.settings.communication.notifications.testModal.body.error.email.invalid',
    }),

    emailLabel: translate({
      id: 'sms4.settings.communication.notifications.testModal.body.label.email',
    }),
  }))

  return api
}

export type Texts = ReturnType<typeof useTexts>
